import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';

interface PropsType {
    className?: string;
}

const SvgWrapper = styled('svg', { label: 'SvgWrapper' })<PropsType>`
    display: block;
    height: 16px;
    width: 16px;
`;

export const PlayIcon = observer(
    ({ className }: PropsType): React.ReactElement => (
        <SvgWrapper
            className={className}
            fill='none'
            height='16'
            viewBox='0 0 16 16'
            width='16'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M3.33325 2L12.6666 8L3.33325 14V2Z'
                stroke='currentColor'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </SvgWrapper>
    )
);
